/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cipher_Ticker_ProtocolInputs */

const bn_cipher_ticker_protocol = /** @type {(inputs: Cipher_Ticker_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ভিজ্যুয়াল জিওলোকেশন প্রোটোকল`)
};

const de_cipher_ticker_protocol = /** @type {(inputs: Cipher_Ticker_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VISUELLES GEOLOKATIONSPROTOKOLL`)
};

const el_cipher_ticker_protocol = /** @type {(inputs: Cipher_Ticker_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ΠΡΩΤΟΚΟΛΛΟ ΟΠΤΙΚΗΣ ΓΕΩΕΝΤΟΠΙΣΗΣ`)
};

const en_cipher_ticker_protocol = /** @type {(inputs: Cipher_Ticker_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VISUAL GEOLOCATION PROTOCOL`)
};

const es_cipher_ticker_protocol = /** @type {(inputs: Cipher_Ticker_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PROTOCOLO DE GEOLOCALIZACIÓN VISUAL`)
};

const fr_cipher_ticker_protocol = /** @type {(inputs: Cipher_Ticker_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PROTOCOLE DE GÉOLOCALISATION VISUELLE`)
};

const hi_cipher_ticker_protocol = /** @type {(inputs: Cipher_Ticker_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विज़ुअल जियोलोकेशन प्रोटोकॉल`)
};

const hu_cipher_ticker_protocol = /** @type {(inputs: Cipher_Ticker_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VIZUÁLIS GEOLOKÁCIÓS PROTOKOLL`)
};

const id_cipher_ticker_protocol = /** @type {(inputs: Cipher_Ticker_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PROTOKOL GEOLOKASI VISUAL`)
};

const it_cipher_ticker_protocol = /** @type {(inputs: Cipher_Ticker_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PROTOCOLLO DI GEOLOCALIZZAZIONE VISIVA`)
};

const ja_cipher_ticker_protocol = /** @type {(inputs: Cipher_Ticker_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビジュアルジオロケーションプロトコル`)
};

const ko_cipher_ticker_protocol = /** @type {(inputs: Cipher_Ticker_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시각적 위치정보 프로토콜`)
};

const nl_cipher_ticker_protocol = /** @type {(inputs: Cipher_Ticker_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VISUEEL GEOLOCATIEPROTOCOL`)
};

const pl_cipher_ticker_protocol = /** @type {(inputs: Cipher_Ticker_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PROTOKÓŁ WIZUALNEJ GEOLOKALIZACJI`)
};

const pt_cipher_ticker_protocol = /** @type {(inputs: Cipher_Ticker_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PROTOCOLO DE GEOLOCAÇÃO VISUAL`)
};

const ru_cipher_ticker_protocol = /** @type {(inputs: Cipher_Ticker_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ПРОТОКОЛ ВИЗУАЛЬНОЙ ГЕОЛОКАЦИИ`)
};

const sv_cipher_ticker_protocol = /** @type {(inputs: Cipher_Ticker_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PROTOKOLL FÖR VISUELL GEOLOCATION`)
};

const tr_cipher_ticker_protocol = /** @type {(inputs: Cipher_Ticker_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GÖRSEL COĞRAFİ KONUMLANDIRMA PROTOKOLÜ`)
};

const uk_cipher_ticker_protocol = /** @type {(inputs: Cipher_Ticker_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ПРОТОКОЛ ВІЗУАЛЬНОГО ГЕОЛОКАЦІЇ`)
};

const vi_cipher_ticker_protocol = /** @type {(inputs: Cipher_Ticker_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GIAO THỨC VỊ TRÍ ĐỊA LÝ`)
};

const zh_cipher_ticker_protocol = /** @type {(inputs: Cipher_Ticker_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视觉地理定位协议`)
};

const zh_hant_cipher_ticker_protocol = /** @type {(inputs: Cipher_Ticker_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`視覺地理定位協議`)
};

/**
* | output |
* | --- |
* | "VISUAL GEOLOCATION PROTOCOL" |
*
* @param {Cipher_Ticker_ProtocolInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const cipher_ticker_protocol = /** @type {((inputs?: Cipher_Ticker_ProtocolInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cipher_Ticker_ProtocolInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_cipher_ticker_protocol(inputs)
	if (locale === "de") return de_cipher_ticker_protocol(inputs)
	if (locale === "el") return el_cipher_ticker_protocol(inputs)
	if (locale === "en") return en_cipher_ticker_protocol(inputs)
	if (locale === "es") return es_cipher_ticker_protocol(inputs)
	if (locale === "fr") return fr_cipher_ticker_protocol(inputs)
	if (locale === "hi") return hi_cipher_ticker_protocol(inputs)
	if (locale === "hu") return hu_cipher_ticker_protocol(inputs)
	if (locale === "id") return id_cipher_ticker_protocol(inputs)
	if (locale === "it") return it_cipher_ticker_protocol(inputs)
	if (locale === "ja") return ja_cipher_ticker_protocol(inputs)
	if (locale === "ko") return ko_cipher_ticker_protocol(inputs)
	if (locale === "nl") return nl_cipher_ticker_protocol(inputs)
	if (locale === "pl") return pl_cipher_ticker_protocol(inputs)
	if (locale === "pt") return pt_cipher_ticker_protocol(inputs)
	if (locale === "ru") return ru_cipher_ticker_protocol(inputs)
	if (locale === "sv") return sv_cipher_ticker_protocol(inputs)
	if (locale === "tr") return tr_cipher_ticker_protocol(inputs)
	if (locale === "uk") return uk_cipher_ticker_protocol(inputs)
	if (locale === "vi") return vi_cipher_ticker_protocol(inputs)
	if (locale === "zh") return zh_cipher_ticker_protocol(inputs)
	return zh_hant_cipher_ticker_protocol(inputs)
});